import { t } from '@lingui/core/macro';
import { BooleanFilter } from './BooleanFilter';
export const limitationOfLiabilityFilterLabel = () => t({ message: 'Limitation of liability', comment: 'Insights: Limitation of liability filter' });
export function LimitationOfLiabilityFilter() {
    return <BooleanFilter name="metadataDocumentLimitationOfLiability" label={limitationOfLiabilityFilterLabel()}/>;
}
